import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

// FAQS is parsed by scripts/generate-snap-routes.js into a FAQPage schema for
// the prerendered HTML, so keep the question/answer shape.
const FAQS = [
  {
    question: 'Is Sortio for Healthcare available now?',
    answer:
      'No. The healthcare plan is in development and we have not set a launch date. Sortio Pro and Team exist today as general file organizers; some practices use them for non-patient files. The healthcare plan will be its own thing, designed around the interviews on this page.',
  },
  {
    question: 'Can I use the current Sortio with patient documents?',
    answer:
      'We do not recommend it yet. The current product was not designed around patient records. It does have a fully local mode and a bring-your-own-key mode, but the healthcare plan is where we will do the work needed to say more, and we will only say it once it is true.',
  },
  {
    question: 'What is the research interview?',
    answer:
      'A ten minute chat with an AI interviewer that asks about how your practice actually handles documents: referrals, scans, records requests, billing paperwork. It asks one question at a time and adapts to your answers. Marcus, the founder, reads every one. It is not a sales call and there is no pitch at the end.',
  },
  {
    question: 'What should I not share in the interview?',
    answer:
      'Anything about a specific patient: names, dates of birth, record numbers, diagnoses tied to a person, or the contents of real documents. Describe the workflow in general terms. The interviewer will steer you back if something identifying comes up.',
  },
  {
    question: 'What do I get for doing it?',
    answer:
      'A single-use code for 50% off your first month of Sortio Pro, usable today or held for the healthcare plan when it launches. It is for finishing the interview, not for what you say in it.',
  },
  {
    question: 'How will I know when the healthcare plan launches?',
    answer:
      'Leave your email in the form at the bottom of this page. We send one email when there is something real to try, and nothing else.',
  },
];

const HealthcareFAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="my-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">Questions</h2>
      </div>
      <div className="max-w-3xl mx-auto space-y-3">
        {FAQS.map((f, i) => (
          <div key={f.question} className="bg-apple-700/30 backdrop-blur-md rounded-2xl border border-apple-600/30 overflow-hidden">
            <button
              type="button"
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between text-left px-6 py-4 text-apple-50 hover:text-sortio-primary transition-colors"
              aria-expanded={open === i}
            >
              <span className="flex items-center gap-3 font-medium">
                <HelpCircle size={18} className="text-sortio-primary shrink-0" />
                {f.question}
              </span>
              {open === i ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </button>
            {open === i && <p className="px-6 pb-5 text-apple-300 leading-relaxed">{f.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HealthcareFAQ;
